import { render, staticRenderFns } from "./CallNoteStringeeInbound.vue?vue&type=template&id=2d8defd6"
import script from "./CallNoteStringeeInbound.vue?vue&type=script&lang=js"
export * from "./CallNoteStringeeInbound.vue?vue&type=script&lang=js"
import style0 from "./CallNoteStringeeInbound.vue?vue&type=style&index=0&id=2d8defd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports